import { makeStyles } from '@material-ui/core/styles';

export const useExtraInfoStyles = makeStyles(() => ({
  container: {
    padding: '0 20px',
    boxSizing: 'border-box',
    maxWidth: `calc(${window.innerWidth}px - 72px)`,
  },
  information: {
    paddingTop: 19,
    display: 'grid',
    gridTemplateColumns: (props) => (props.mobile ? '100%' : '50% 50%'),
    alignItems: 'flex-start',
  },
  detail: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    '&:not(:last-child)': {
      marginBottom: (props) => (props.mobile ? 15 : 0),
    },
    '& :not(:last-child)': {
      marginRight: 10,
    },
  },
  text: {
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
  textSize: {
    fontSize: 16,
  },
}));
